export default __webpack_public_path__ + "static/media/ioanna_koutsiona.426837bd.png";